import{__exports as e}from"../../../_virtual/ReactTrackingContext.js";import t from"react";!function(e){var a;Object.defineProperty(e,"__esModule",{value:!0}),e.default=void 0;var r=((a=t)&&a.__esModule?a:{default:a}).default.createContext({});e.default=r}(e);
//# sourceMappingURL=ReactTrackingContext.js.map
